import { ModelItem, dateItemType } from "../../../common";
import { DateRange } from "sb-resp-lib";
import { action, observable } from "mobx";

export type datesData = {
    id : string;
    order: number;
    dayOfWeek: string;
    formattedDate: string;
    from: Date;
    timeRange: DateRange.TimeRangeEnum;
}

export class DatesModel implements ModelItem {

    id : string;
    @observable
    from: Date;
    timeRange: DateRange.TimeRangeEnum;
    formattedDate: string;
    order: number;
    dayOfWeek : string;
    type: dateItemType = "dates";

    constructor(data: datesData) {
        this.id = data.id;
        this.from = data.from;
        this.timeRange = data.timeRange;
        this.dayOfWeek = data.dayOfWeek;
        this.formattedDate = data.formattedDate;
        this.order = data.order;
    }

    @action.bound update(newItem: Partial<DatesModel>): void {
        newItem.id && (this.id = newItem.id);
        newItem.order && (this.order = newItem.order);
        this.updateTimeProps(newItem);
    }

    private updateTimeProps(newItem: Partial<DatesModel>) {
        newItem.from && (this.from = newItem.from);
        newItem.timeRange && (this.timeRange = newItem.timeRange);
        newItem.dayOfWeek && (this.dayOfWeek = newItem.dayOfWeek);
        newItem.formattedDate && (this.formattedDate = newItem.formattedDate);
    }
}